import { WizardStep } from '@sec-loans-ui/ifp-loans/wizard/wizardMachine'
import { LogoIconType } from '@ui-components/global/ComponentProps'
import { AfterCareStep } from '@ui-components/layout/AfterCareStep'

// TODO DIG-5783, DIG-5784, DIG-5785 - Actual Implementation
export const EndStep = () => {
  return (
    <AfterCareStep
      stepId={WizardStep.EndStep}
      icon={LogoIconType.SPankki}
      topic={''}
      headerButtonProps={{
        onHeaderButtonClick: () => null,
        headerButtonLabel: 'PLACEHOLDER',
      }}
    />
  )
}
